export const convertPrice = (price: number | string | null) => {
  if (typeof price === 'string') {
    const trimmed = price.trim();
    if (!/^\d+(\.\d+)?$/.test(trimmed) || /[eE]/.test(trimmed)) return null;
    price = parseFloat(price);
    if (isNaN(price)) return null;
  }

  if (price === 0) return 0;
  if (!price) return null;
  return Math.floor(price);
};
